<template>
    <el-row class="warp">
        <el-col :span="24" class="warp-main" v-loading="loading" element-loading-text="拼命加载中">
            <!--工具条-->
            <el-col :span="24" class="toolbar" style="padding-bottom: 0px">
                <el-form :inline="true" ref="filters" :model="filters">
                    <el-form-item>
                        <el-button type="primary" @click="add()">增加</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
            <!--列表-->
            <el-table :data="pros" highlight-current-row v-loading="loading" border style="width: 100%">
                <el-table-column label="序号" type="index" :index="indexMethod"></el-table-column>
                <el-table-column label="广告图" prop="adurl">
                    <template slot-scope="scope">
                        <div class="demo-image__preview">
                            <el-image style="width: 60px; height: 40px" :src="scope.row.adurl">
                            </el-image>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="广告ID" prop="id"></el-table-column>
                <el-table-column label="更新时间" prop="updatetime" width="180" :formatter="formatTime"></el-table-column>
                <el-table-column label="操作" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="text" @click="edit(scope.$index, scope.row)">修改</el-button>
                        <el-button type="text" @click="del(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-col :span="24" class="toolbar">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page"
                    :page-sizes="[10, 20, 50]" :page-size="10" layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </el-col>
            <!-- 修改页面 -->
            <el-dialog :title="dianame" :visible.sync="editFormVisible" center :close-on-click-modal="false"
                @close="resetForm('editForm')">
                <el-form :model="editForm" label-width="80px" :rules="editFormRules"  ref="editForm" class="demo-ruleForm">

                    <el-form-item label="广告图" prop="adurl">
                        <el-upload class="avatar-uploader" action="/mallapi/MallApi/file/upload" :show-file-list="false"
                            :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                            <img v-if="editForm.adurl" :src="editForm.adurl" class="avatar">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            <div class="el-upload__tip" slot="tip" style="font-weight: bold">图片只能是 JPG
                                格式，且不超过2M
                            </div>
                        </el-upload>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click.native="editFormVisible = false">取消</el-button>
                    <el-button type="primary" @click="submit('editForm')" :loading="addLoading">提交</el-button>
                </div>
            </el-dialog>
        </el-col>
    </el-row>
</template>
<script>


import MallApi from "../../../api/goods/adversiteapi"
import moment from 'moment'
export default {
    data() {
        return {
            filters: {
            },

            loading: false,
            total: 0,
            page: 1,
            limit: 10,
            pros: [],
            dianame:'添加',

            editFormVisible: false,
            editForm: {
                adurl:''
            },
            editFormRules: {
                adurl: [{ required: true, message: "请上传广告图片", trigger: "blur" }]
            },
            dialogVisible: false,
            //提交按钮状态
            addLoading: false,
        };

    },
    methods: {
        indexMethod(index) {
            return (index + 1) + (this.page - 1) * (this.limit)
        },
        //时间格式转化
        dateFormat(dateData) {
            var date = new Date(dateData);
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? "0" + m : m;
            var d = date.getDate();
            d = d < 10 ? "0" + d : d;
            var H = date.getHours();
            H = H < 10 ? "0" + H : H;
            var ms = date.getMinutes()
            ms = ms < 10 ? "0" + ms : ms;
            var s = date.getMilliseconds()
            s = s < 10 ? "0" + s : s;
            const time = y + "-" + m + "-" + d + " " + H + ":" + ms + ":" + s;
            return time;
        },
        formatTime(row, column) {
            let date = row[column.property];
            if (date === undefined) {
                return ''
            }
            return moment(date).format("YYYY-MM-DD HH:mm:ss")
        },
        handleCurrentChange(val) {
            this.page = val;
            this.search();
        },
        handleSizeChange(val) {
            this.limit = val;
            this.search();
        },
        handleSearch() {
            this.total = 0;
            this.page = 1;
            this.search();
        },
        search: function () {
            let params = {
                pageNum: this.page,
                pageSize: this.limit,
            };

            this.loading = true

            let that = this
            MallApi.list(params)
                .then(
                    function (result) {
                        that.loading = false;
                        if (result && result.data.totalSize) {
                            that.total = result.data.totalSize;
                            that.pros = result.data.content;
                        } else {
                            that.total = 0;
                            that.pros = null;
                        }
                    },
                    function (err) {
                        that.loading = false;
                        that.$message.error({
                            showClose: true,
                            message: err.toString(),
                            duration: 2000,
                        });
                    }
                )
                .catch(function (error) {
                    that.loading = false;
                    console.log(error);
                    that.$message.error({
                        showClose: true,
                        message: "请求出现异常",
                        duration: 2000,
                    });
                });
        },


        resetForm(formName) {
            this.$refs['editForm'].resetFields();
        },
        //页面
        add: function (index, row) {
            this.editFormVisible = true;
            this.dianame='添加'
        },
        edit: function (index, row) {
            this.editFormVisible = true;
            this.editForm = Object.assign({}, row)
            this.dianame='编辑'
        },
        //保存
        submit(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let that = this;
                    this.addLoading = true;
                    MallApi.save(this.editForm).then(function (result) {
                        if (0 === result.code) {
                            that.addLoading = false;
                            that.$message.success({
                                showClose: true,
                                message: "操作成功",
                                duration: 2000,
                            });
                            that.resetForm();
                            that.editFormVisible = false;
                            that.search();
                        } else {
                            that.$message.error({
                                showClose: true,
                                message: result.message || "操作失败",
                                duration: 2000,
                            });
                            that.addLoading = false;
                        }
                    });
                }
            })
        },

        del(e) {
            let that = this;
            this.$confirm("确认删除该记录吗?", "提示", { type: "warning" })
                .then(() => {
                    that.loading = true;
                    MallApi.delete({ id: e.id })
                        .then(
                            function (result) {
                                that.loading = false;
                                if (result && parseInt(result.code) === 0) {
                                    that.$message.success({
                                        showClose: true,
                                        message: "删除成功",
                                        duration: 1500,
                                    });
                                    that.search();
                                } else {
                                    that.$message.error({
                                        showClose: true,
                                        message: result.message,
                                        duration: 1500,
                                    });
                                }
                            },
                            function (err) {
                                that.loading = false;
                                that.$message.error({
                                    showClose: true,
                                    message: err.toString(),
                                    duration: 2000,
                                });
                            }
                        )
                        .catch(function (error) {
                            that.loading = false;
                            console.log(error);
                            that.$message.error({
                                showClose: true,
                                message: "请求出现异常",
                                duration: 2000,
                            });
                        });
                })
                .catch(() => { });
        },


        //缩略图上传
        handleAvatarSuccess(res) {
            if (res.code === 0) {
                this.editForm.adurl = "data:image/jpeg;base64," + res.data
                this.$forceUpdate() //强制渲染
            } else {
                this.$message.error(res.message)
            }
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/jpeg';
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isJPG) {
                this.$message.error('上传头像图片只能是 JPG 格式!');
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 2MB!');
            }
            return isJPG && isLt2M;
        },

    },

    mounted() {
        this.handleSearch()
    },
};
</script>

<style scoped></style>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
